import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
const rows = [{
  con: 'Plan claro de 6 hs semanales, paso a paso',
  sin: 'Entrenás a la deriva, sin saber si vas bien'
}, {
  con: 'Sabés cómo combinar nado, bici y running',
  sin: 'Improvisás y te estancás sin entender por qué'
}, {
  con: 'Calculadoras de hidratación y proteína listas',
  sin: 'Calambres, fatiga y nutrición a prueba y error'
}, {
  con: 'Guía de suplementos: qué sirve y qué no',
  sin: 'Gastás plata en productos que no necesitás'
}, {
  con: 'Llegás a tu primer triatlón con confianza',
  sin: 'Miedo a anotarte y a llegar mal preparado'
}, {
  con: 'Resultados sin descuidar trabajo ni familia',
  sin: 'Frustración y abandono a las pocas semanas'
}];
export function Testimonials() {
  return <section className="py-16 bg-brand-dark" data-id="element-121">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="text-center mb-8" data-id="element-123">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-124">
            La diferencia es enorme
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-125">
            Mirá cómo cambia tu camino al triatlón con o sin el sistema.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="grid md:grid-cols-2 gap-4" data-id="element-126">
          {/* WITH the pack */}
          <div className="bg-brand-green/[0.06] border-2 border-brand-green/40 rounded-2xl overflow-hidden order-2 md:order-1 shadow-[0_0_30px_rgba(204,255,0,0.08)]" data-id="element-127">
            <div className="bg-brand-green text-brand-dark text-center py-2.5 px-3" data-id="element-128">
              <p className="font-bold text-sm md:text-base tracking-tight" data-id="element-129">
                ✅ CON “Dominá tu primer triatlón”
              </p>
            </div>
            <ul className="p-4 md:p-5 space-y-2.5" data-id="element-130">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5 text-white" data-id="element-131">
                  <span className="flex-shrink-0 mt-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-brand-green text-brand-dark" data-id="element-132">
                    <Check size={12} strokeWidth={3} data-id="element-133" />
                  </span>
                  <span className="text-sm leading-snug font-medium" data-id="element-134">
                    {r.con}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* WITHOUT the pack */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl overflow-hidden order-1 md:order-2" data-id="element-135">
            <div className="bg-white/[0.06] text-white/70 text-center py-2.5 px-3 border-b border-white/10" data-id="element-136">
              <p className="font-bold text-sm md:text-base tracking-tight" data-id="element-137">
                ❌ SIN un sistema probado
              </p>
            </div>
            <ul className="p-4 md:p-5 space-y-2.5" data-id="element-138">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5 text-white/50" data-id="element-139">
                  <span className="flex-shrink-0 mt-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-red-500/15 text-red-400" data-id="element-140">
                    <X size={12} strokeWidth={3} data-id="element-141" />
                  </span>
                  <span className="text-sm leading-snug" data-id="element-142">{r.sin}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}